import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import MiniCheckBox from 'src/components/modules/MiniCheckBox/MiniCheckBox';
import { ExternalLinks } from 'src/latest/src/constants';
import { updateContinueButton } from 'src/redux/actions/questionnaireActions';
import { PaymentExplanationPageButtonStatus } from './PaymentExplanationPageConstant';
import './PaymentExplanationPage.scss';

interface PaymentExplanationPageProps {
  choices: any[];
  onToken: (status: string, choice: any) => void;
  metaData: any;
}

const PaymentExplanationPage: React.FC<PaymentExplanationPageProps> = ({
  choices,
  onToken,
  metaData,
}) => {
  const { t } = useTranslation('components');
  const choice = choices ? choices?.[0] : [];
  const dispatch = useDispatch();
  const [isConsentChecked, setIsConsentChecked] = useState<boolean>(
    Boolean(choice?.selected),
  );

  useEffect(() => {
    dispatch(
      updateContinueButton({
        buttonStatus: isConsentChecked
          ? PaymentExplanationPageButtonStatus?.ENABLED
          : PaymentExplanationPageButtonStatus?.DISABLED,
      }),
    );
  }, [isConsentChecked, dispatch]);

  useEffect(() => {
    if (isConsentChecked) {
      onToken(
        `${PaymentExplanationPageButtonStatus.FLAT_FEE_AMOUNT}:${metaData?.flat_fee_amount}`,
        choice,
      );
    }
  }, [isConsentChecked]);

  const handleMiniCheckbox = () => {
    setIsConsentChecked(prev => !prev);
  };

  return (
    <div className="pt-2 pb-4 i2icharges-page">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-xl-12">
            {/* <div className="card shadow-sm">
              <div className="card-body p-4 px-md-5">
                <div className="d-flex flex-column align-items-center">
                  <h2 className="h3 mb-0">
                    {t('paymentExplanationPage.title')}
                  </h2>
                </div>
              </div>
            </div> */}
            <div className="card shadow-sm">
              <div className="card-body card-lower-body p-5 ">
                <div className="mb-4">
                  <h2 className="h4 mb-2">
                    {t('paymentExplanationPage.subtitle')}
                  </h2>
                  <p>{t('paymentExplanationPage.howPricingWorks')}</p>
                </div>
                <div className="mb-4">
                  <h2 className="h4 mb-2">
                    {t('paymentExplanationPage.transparentAndTieredPricing')}
                  </h2>
                  <p>
                    {t('paymentExplanationPage.tieredPricingText1')}{' '}
                    <strong>${metaData?.flat_fee_amount}</strong>{' '}
                    {t('paymentExplanationPage.tieredPricingText2')}
                  </p>
                </div>
                <div className="mb-4">
                  <h2 className="h4 mb-2">
                    {t('paymentExplanationPage.ourFee')}
                  </h2>
                  <p>{t('paymentExplanationPage.ourFeeText')}</p>
                </div>
                <div className="mb-5">
                  <h2 className="h4 mb-2">
                    {t('paymentExplanationPage.refundPolicy')}
                  </h2>
                  <p>{t('paymentExplanationPage.refundPolicyText')}</p>
                </div>
                <div>
                  <MiniCheckBox
                    text={t('paymentExplanationPage.termsAndConditionsText', {
                      agreementUrl: ExternalLinks.platformAndServicesAgreement,
                    })}
                    isCheckFirst={true}
                    isActive={isConsentChecked}
                    onClick={handleMiniCheckbox}
                    value=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentExplanationPage;
